module.exports = __webpack_public_path__ + "img/team-1-5.938635b9.jpeg";